'use client';

import Image from 'next/image';

export function CeoMessageComponent() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-12">
            {/* CEO Image */}
            <div className="relative">
              <div className="w-64 h-64 rounded-full overflow-hidden border-4 border-white shadow-xl relative z-10">
                <Image
                  src="/images/ceo-image.png"
                  alt="Gabriel Pendleton - CEO of WarrantyPilot"
                  width={256}
                  height={256}
                  className="object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-32 h-8 bg-[#00B67A]/30 rounded-full -z-0"></div>
              <div className="absolute -top-4 -left-4 w-32 h-8 bg-[#00B67A]/30 rounded-full -z-0"></div>
            </div>

            {/* CEO Quote */}
            <div className="md:flex-1">
              <h2 className="text-3xl font-bold mb-6">Our Mission</h2>
              <div className="relative">
                <div className="absolute -left-8 -top-6 text-[#00B67A] opacity-20">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"></path>
                  </svg>
                </div>
                <blockquote className="text-xl md:text-2xl font-medium text-gray-700 mb-6 pl-4">
                  I built WarrantyPilot because I was frustrated with the lack of transparency in the extended warranty
                  industry. Too many people were paying too much for coverage they didn't understand. Our mission is
                  simple: make vehicle protection transparent, affordable, and accessible to everyone.
                </blockquote>
                <div className="flex items-center">
                  <div>
                    <p className="font-bold text-gray-900">Gabriel Pendleton</p>
                    <p className="text-[#00B67A]">Co-Founder & CEO</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-16 flex flex-col-reverse md:flex-row items-center gap-12">
            {/* Co-Founder Quote */}
            <div className="md:flex-1">
              <h2 className="text-3xl font-bold mb-6 md:text-right">Our Technology</h2>
              <div className="relative">
                <div className="absolute -right-8 -top-6 text-[#00B67A] opacity-20">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"></path>
                  </svg>
                </div>
                <blockquote className="text-xl md:text-2xl font-medium text-gray-700 mb-6 md:pr-4 md:text-right">
                  When we set out to build WarrantyPilot, I was determined to make technology the great equalizer for
                  car owners. We've built a platform where pricing is upfront, coverage is easy to understand, and
                  comparing your options takes seconds, not days of phone calls. Every feature we ship is designed to
                  put you in control of protecting your vehicle.
                </blockquote>
                <div className="flex items-center md:justify-end">
                  <div className="md:text-right">
                    <p className="font-bold text-gray-900">Shawn Freeman</p>
                    <p className="text-[#00B67A]">Co-Founder & CTO</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Co-Founder Image */}
            <div className="relative">
              <div className="w-64 h-64 rounded-full overflow-hidden border-4 border-white shadow-xl relative z-10">
                <Image
                  src="/images/shawn.png"
                  alt="Shawn Freeman - Co-Founder & CTO of WarrantyPilot"
                  width={256}
                  height={256}
                  className="object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 w-32 h-8 bg-[#00B67A]/30 rounded-full -z-0"></div>
              <div className="absolute -top-4 -right-4 w-32 h-8 bg-[#00B67A]/30 rounded-full -z-0"></div>
            </div>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="flex items-center justify-center h-12 w-12 rounded-full bg-[#00B67A]/10 text-[#00B67A] mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2">30 Day Money Back</h3>
              <p className="text-gray-600">
                Try our service risk-free. If you're not completely satisfied, get a full refund within 30 days of
                purchase.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="flex items-center justify-center h-12 w-12 rounded-full bg-[#00B67A]/10 text-[#00B67A] mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path>
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2">Unmatched Pricing</h3>
              <p className="text-gray-600">
                We'll match or beat any competitor's price for the same coverage. Our commitment to value is
                unparalleled.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="flex items-center justify-center h-12 w-12 rounded-full bg-[#00B67A]/10 text-[#00B67A] mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2">Save $2,500 or more</h3>
              <p className="text-gray-600">
                Our customers save an average of $2000+ compared to dealer prices. Maximum protection at minimum cost.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
